import React from 'react';
import './Textarea.css';

const Textarea = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  rows = 4,
  disabled = false,
  readOnly = false,
  required = false,
  maxLength,
  error,
  id,
  className = '',
  style = {}
}) => {
  const textareaId = id || name || `textarea-${Math.random().toString(36).substr(2, 9)}`;
  const isFilled = value && value.trim().length > 0;

  return (
    <div className={`textarea-container ${className}`}>
      {label && (
        <label htmlFor={textareaId} className="textarea-label">
          {label} {required && <span className="required">*</span>}
        </label>
      )}
      <textarea
        id={textareaId}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
        maxLength={maxLength}
        className={`form-control textarea-field 
          ${isFilled ? 'filled' : ''} 
          ${error ? 'error' : ''}`}
        style={style}
      />
      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default Textarea;
